import { useTranslation } from "react-i18next";

import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

type StageLoadingVariant = "page" | "list" | "panel";

const BLOCK = "motion-reduce:animate-none";

// Esqueleto único das etapas do Configuration Server: o texto fica só para leitor de tela.
export function StageLoading({ variant, label }: { variant: StageLoadingVariant; label?: string }) {
  const { t } = useTranslation();
  const block = (className: string, key?: number) => (
    <Skeleton key={key} aria-hidden="true" className={cn(className, BLOCK)} />
  );
  return (
    <div role="status" aria-live="polite" aria-busy="true" data-testid="stage-loading" data-variant={variant} className="space-y-4">
      <span className="sr-only">{label ?? t("Loading…")}</span>
      {variant === "page" && (
        <>
          {block("h-24 w-full rounded-xl")}
          <div className="grid gap-4 lg:grid-cols-3">
            {[0, 1, 2].map((index) => block("h-56 rounded-xl", index))}
          </div>
        </>
      )}
      {variant === "list" && (
        <>
          {block("h-9 w-full")}
          {[0, 1, 2, 3, 4, 5].map((index) => block("h-12 w-full rounded-md", index))}
        </>
      )}
      {variant === "panel" && (
        <div className="space-y-4 p-4">
          {[0, 1, 2, 3].map((index) => block("h-10 w-full rounded-md", index))}
        </div>
      )}
    </div>
  );
}
